import { SecondaryButton, SecondaryButtonProps, useModal } from '@wrisk/ui-components/src'
import React, { FunctionComponent } from 'react'

import { isAuthenticated } from '../../../../domain'
import { useErrorHandlingAsyncCallback } from '../../../../hooks/errors'
import {
  TKey,
  useWriskTranslation,
} from '../../../../infrastructure/internationalisation'
import { usePrincipal, useProposer } from '../../../authentication'
import { useProduct } from '../../../product/ProductProvider'
import { useProposal } from '../../../product/proposal/ProposalProvider'
import { ProposalSaveModal } from './ProposalSaveModal'

const tKey = TKey('components.proposal-save-button')

export const ProposalSaveButton: FunctionComponent<SecondaryButtonProps> = (props) => {
  const { t } = useWriskTranslation()

  const principal = usePrincipal()

  const {
    product: { proposalSave },
  } = useProduct()
  const { proposer } = useProposer()

  const { commit, loading: commitLoading } = useProposal()
  const { show, hide } = useModal()

  const { execute: handleClick, loading: clickLoading } = useErrorHandlingAsyncCallback(
    async () => {
      await commit()
      if (proposalSave) {
        show({
          content: <ProposalSaveModal onClose={hide} form={proposalSave} tKey={tKey} />,
        })
      }
    },
  )

  return !isAuthenticated(proposer, principal) && proposalSave?.length ? (
    <SecondaryButton
      onClick={handleClick}
      disabled={commitLoading}
      loading={clickLoading}
      {...props}
    >
      {t(tKey('actions', 'save'))}
    </SecondaryButton>
  ) : null
}
